var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0ZM12.8125 7.94433C13.2246 7.92003 13.597 8.16633 13.8794 8.6035L16.6138 13.789C16.9017 14.4035 16.7381 15.0614 16.3086 15.5005L15.0562 16.7529C14.9789 16.8588 14.928 16.9781 14.9268 17.1093C15.4071 18.9685 16.864 20.6834 18.1495 21.8628C19.4349 23.0421 20.8164 24.6388 22.6099 25.0171C22.8315 25.0789 23.1031 25.1011 23.2617 24.9536L24.7168 23.4717C25.2191 23.091 25.9457 22.9065 26.4819 23.2178H26.5063L31.4404 26.1304C32.1646 26.5844 32.2397 27.4619 31.7211 27.9956L28.3228 31.3672C27.8209 31.8819 27.1542 32.0549 26.5064 32.0557C23.6415 31.9698 20.9345 30.5637 18.711 29.1187C15.0613 26.4636 11.7136 23.1705 9.61183 19.1919C8.80577 17.5236 7.85887 15.3949 7.94923 13.5328C7.9573 12.8322 8.14683 12.1459 8.64017 11.6944L12.0386 8.29597C12.3033 8.0707 12.5652 7.95893 12.8125 7.94433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.98347b61265969121c86fa0546f0d935.svg";
export { ForwardRef as ReactComponent };